<!-- Small chart - used in Dashboard top widget and inside Trade Voucher -->
<div
	class="price-chart-tile dashboard"
	(click)="onTradableClick(tradable)"
	(keydown.enter)="onTradableClick(tradable)"
	[tabindex]="-1">
	<!-- Chart -->
	<div class="price-chart-tile-chartwrapper">
		<line-chart [chartConfig]="chartConfig$ | async"> </line-chart>
	</div>

	<!-- Details -->
	<div class="price-chart-tile-content" style="background-image: none">
		<div class="price-chart-tile-top">
			<span>
				<img
					[src]="tradable?.getLogo()"
					[style.width.px]="20"
					(error)="img.src = tradable?.getDefaultLogo()"
					alt="{{ 'logo_alt_text' | translate }}"
					#img />
			</span>
			<span class="ml-5 asset-name">{{ tradable?.getName() | capitalize }}</span>
		</div>
		<div class="price-chart-tile-bottom">
			<div class="price-chart-tile-amount-change">
				<span class="price-chart-tile-amount">
					<strong>
						{{
							getFiatAmount()
								| fiat_precision_symbol
									: {
											id: getFiat()?.getId(),
											symbol: true,
											removeCurrency: isIndex(),
											currencies: [getFiat(), tradable]
									  }
						}}
					</strong>
				</span>
			</div>
			<div
				class="font-size-12"
				[ngClass]="{
					'price-up': getChangeFiat() > 0,
					'price-down': getChangeFiat() < 0
				}">
				{{
					getAbsoluteChange()
						| fiat_precision_symbol
							: {
									id: getFiat()?.getId(),
									symbol: true,
									removeCurrency: isIndex(),
									currencies: [getFiat(), tradable]
							  }
						| value_change_prefix: { isProfit: getChangeFiat() > 0 }
				}}
				<span class="price-chart-tile-amount-change">
					({{
						getAbsolutePercentChange()
							| fiat_precision
							| value_change_prefix: { isProfit: getChangeFiat() >= 0 }
							| percent_symbol
					}}
					<span
						class="rate-indicator"
						[ngClass]="{
							'mod-up': getChangeFiat() >= 0,
							'mod-down': getChangeFiat() < 0
						}"></span>
					)
				</span>
			</div>
		</div>
	</div>
</div>
